import { Box, Button, Card, Container, Divider, Grid, Stack, Typography, alpha, styled, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import Image from 'src/components/image';
import Label from 'src/components/label';
import { useSettingsContext } from 'src/components/settings';
import { RARITY_CONFIG } from 'src/config/config-global';

const DATA = [
  {
    type: 'TRAINER',
    items: {
      COMMON: {
        imgUrl: './assets/images/products/COMMON_TRAINER_V1.png',
        rarity: 'COMMON',
      },
      RARE: {
        imgUrl: './assets/images/products/RARE_TRAINER_V1.png',
        rarity: 'RARE',
      },
      EPIC: {
        imgUrl: './assets/images/products/EPIC_TRAINER_V1.png',
        rarity: 'EPIC',
      },
      LEGEND: {
        imgUrl: './assets/images/products/LEGEND_TRAINER_V1.png',
        rarity: 'LEGEND',
      },
    },
  },

  {
    type: 'WALKER',
    items: {
      COMMON: {
        imgUrl: './assets/images/products/COMMON_WALKER_V1.png',
        rarity: 'COMMON',
      },
      RARE: {
        imgUrl: './assets/images/products/RARE_WALKER_V1.png',
        rarity: 'RARE',
      },
      EPIC: {
        imgUrl: './assets/images/products/EPIC_WALKER_V1.png',
        rarity: 'EPIC',
      },
      LEGEND: {
        imgUrl: './assets/images/products/LEGEND_WALKER_V1.png',
        rarity: 'LEGEND',
      },
    },
  },

  {
    type: 'RUNNER',
    items: {
      COMMON: {
        imgUrl: './assets/images/products/COMMON_RUNNER_V1.png',
        rarity: 'COMMON',
      },
      RARE: {
        imgUrl: './assets/images/products/RARE_RUNNER_V1.png',
        rarity: 'RARE',
      },
      EPIC: {
        imgUrl: './assets/images/products/EPIC_RUNNER_V1.png',
        rarity: 'EPIC',
      },
      LEGEND: {
        imgUrl: './assets/images/products/LEGEND_RUNNER_V1.png',
        rarity: 'LEGEND',
      },
    },
  },
];

const StyledNFTBox = styled(Stack)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,

  padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
}));

function HomeNFT() {
  const theme = useTheme();

  const settings = useSettingsContext();

  const isDarkMode = settings.themeMode === 'dark';

  const [hovered, setHovered] = useState(null);

  const [selected, setSelected] = useState({
    TRAINER: DATA[0].items.COMMON,
    WALKER: DATA[1].items.COMMON,
    RUNNER: DATA[2].items.COMMON,
  });

  const handleSelect = (name, data) => {
    setSelected((prev) => ({ ...prev, [name]: data }));
  };

  useEffect(() => {
    if (hovered) return () => {};

    const TYPES = ['COMMON', 'RARE', 'EPIC', 'LEGEND'];
    let number = 0;

    const interval = setInterval(() => {
      if (number === 3) {
        number = 0;
      } else {
        number += 1;
      }

      setSelected((prev) => ({
        ...prev,
        TRAINER: DATA[0].items[TYPES[number]],
        WALKER: DATA[1].items[TYPES[number]],
        RUNNER: DATA[2].items[TYPES[number]],
      }));
    }, 3000);

    return () => clearInterval(interval);
  }, [hovered]);

  return (
    <Container maxWidth="lg">
      <Stack sx={{ py: { xs: 5, md: 10 } }}>
        <Typography variant="h2" color="primary" align="center" mb={5}>
          WALKUP NFT
        </Typography>

        <Stack mt={4}>
          <Grid container spacing={3}>
            {DATA.map((cardData, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <Stack
                  component={Card}
                  p={2}
                  spacing={2}
                  onMouseEnter={(e) => {
                    setHovered(e.target.id);
                  }}
                  onMouseLeave={() => {
                    setHovered(null);
                  }}
                  id={`card-${index + 1}`}
                >
                  <StyledNFTBox
                    sx={{
                      background: alpha(RARITY_CONFIG[selected[cardData.type].rarity]?.color, 0.1),
                      ...(isDarkMode && {
                        border: `2px solid ${alpha(RARITY_CONFIG[selected[cardData.type].rarity]?.color, 0.2)}`,
                      }),
                    }}
                  >
                    <Box>
                      <Label
                        sx={{
                          borderRadius: 999,
                          background: RARITY_CONFIG[selected[cardData.type].rarity]?.color,
                          color: theme.palette.common.white,
                        }}
                      >
                        {selected[cardData.type].rarity}
                      </Label>
                    </Box>

                    <Image src={selected[cardData.type].imgUrl} alt={selected[cardData.type].rarity} />
                  </StyledNFTBox>

                  <Stack divider={<Divider />}>
                    <Typography
                      align="center"
                      variant="h5"
                      lineHeight={1}
                      py={2}
                      sx={{ color: RARITY_CONFIG[selected[cardData.type].rarity]?.color }}
                    >
                      {cardData.type}
                    </Typography>

                    <Stack direction="row" spacing={2} flexWrap="wrap" mt={2}>
                      {['COMMON', 'RARE', 'EPIC', 'LEGEND'].map((option, j) => (
                        <Button
                          key={j}
                          size="small"
                          variant={selected[cardData.type].rarity === option ? 'contained' : 'outlined'}
                          sx={{ borderRadius: 999, px: 3 }}
                          onClick={() => {
                            handleSelect(cardData.type, cardData.items[option]);
                          }}
                        >
                          <Typography lineHeight={1} variant="subtitle2" textTransform="capitalize">
                            {option.toLowerCase()}
                          </Typography>
                        </Button>
                      ))}
                    </Stack>
                  </Stack>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Stack>
    </Container>
  );
}

export default HomeNFT;
